import React, { useEffect, useState } from 'react'
import Header from '@/components/Header'
import {Content, ActiveCard, ActivtyContainer, Center} from '@/styles/acitvityInfo'
import {getActivity} from '@/api/user-new'
import ListView from '@/components/ListView'
import moment from 'moment'
 import { jumpTo, duplicatePush, userBehaver} from '@/utils'
import { uploadTrace } from '@/api/base';
import { connect } from 'react-redux'
import PageLoading from '@/components/PageLoading'

const Activitys = ({ userId }) => {
  const [activeList, setActiveList] = useState([])
  let   [page] = useState(1)
  const [, settotal] = useState(0)
  const [refreshing, setrefreshing] = useState(false)
  const [isLoading, setisLoading] = useState(false)
  const [endText, setEndText] = useState('')

  const cardClick = data => {
      const timestamp = `${new Date().valueOf()}`;
      const event = {
        source: 'activity',
        event: 'click',
        eventTime: timestamp,
        "args":{content_id: data.id},
        type: 'activity'
      }
      // tracestat: "[{"source":"old_advertisement","event":"click","args":"{"content_id":24}","type":"splash"}]"  %E5%BC%80%E5%B1%8F%E9%A1%B5%E7%9A%84
      uploadTrace({
        traceStat: JSON.stringify([event]),
        timestamp: timestamp,
        nonce: data.id
      })
    // }
    if(data.url){
      let link = data.url;
      if (data.isAppNeedLogin) {
        if (link.includes('?')) {
          link = link + '&userNo=' + userId
        } else {
          link = link + '?userNo=' + userId
        }
      }
      console.log(link, 'link');
      jumpTo(link)

      userBehaver({
        activeIdKey: "Activity_View",
        conId: `${data.id}`
      });
    }
  }
  const getActivitys = (data) => {
    const params = {
      page: data? data : page,
      size: 100
    }

    getActivity(params).then(res=>{
      let data = res.content || []
      setActiveList( duplicatePush(activeList, data, 'id'))
      settotal(res.total)
      setrefreshing(false)
      setisLoading(false)
    })
  }
  const onRefresh = () => {
    setrefreshing(true)
    getActivitys(0)
  }
  const onEndReached = (event) =>{
    setEndText('暂无更多数据')
  }
  const  CardList = (rowData) =>(
      <ActiveCard onClick={()=>cardClick(rowData)} state={rowData.state}>
        <div className='img-container'>
         {rowData.state===2  && <span className='activity-state'></span>}
          <img src={rowData.image} alt={rowData.title}/>
        </div>
        <div className='content'>
          <div className='title'>{rowData.introduce}</div>
          <div className='date'>{`${moment(rowData.startTime).format('YYYY/MM/DD')} ~ ${moment(rowData.endTime).format('YYYY/MM/DD')}`}</div>
        </div>
      </ActiveCard >
  )
  useEffect(() => {
    getActivitys()
  }, [])
  return (
  <ActivtyContainer>
    <Header  title={'活动中心'} />
    <Content justy={true}>
    {activeList.length > 0 ? <ListView  OnRefresh={onRefresh} OnEndReached={onEndReached}  endText={endText} refreshing={refreshing} content={activeList} isLoading={isLoading} renderRow={CardList}></ListView>: <Center><PageLoading /></Center>}
    </Content>
  </ActivtyContainer>
  )
}

const mapStateToProps = (state) => ({
  userId: state.user.userId
});

export default React.memo(connect(mapStateToProps)(Activitys));



// WEBPACK FOOTER //
// ./src/views/activitys/index.js